import { Card, Flex, Table, Typography } from "antd";
import React from "react";

import notification from "../../../../assets/icons/notification.svg";
import "./styles.css";

export default function PatientsWithHighestBalance() {
  const testPatientWithHeighestBalance = [
    { patient: { first_name: "Daraya", last_name: "Rouzbahani" }, overdu_by: "2025-02-02", outstanding_balance: "850000" },
    { patient: { first_name: "Daraya", last_name: "Rouzbahani" }, overdu_by: "2025-02-02", outstanding_balance: "700000" },
    { patient: { first_name: "Daraya", last_name: "Rouzbahani" }, overdu_by: "2025-02-02", outstanding_balance: "500000" },
    { patient: { first_name: "Daraya", last_name: "Rouzbahani" }, overdu_by: "2025-02-02", outstanding_balance: "900000" },
    { patient: { first_name: "Daraya", last_name: "Rouzbahani" }, overdu_by: "2025-02-02", outstanding_balance: "900000" },
    { patient: { first_name: "Daraya", last_name: "Rouzbahani" }, overdu_by: "2025-02-02", outstanding_balance: "900000" },
    { patient: { first_name: "Daraya", last_name: "Rouzbahani" }, overdu_by: "2025-02-02", outstanding_balance: "900000" },
    { patient: { first_name: "Daraya", last_name: "Rouzbahani" }, overdu_by: "2025-02-02", outstanding_balance: "900000" },
  ];

  const patientWithHighestBalanceColumns = [
    {
      key: "patient",
      title: "Patient",
      dataIndex: "patient",
      render: (patient) => `${patient.first_name} ${patient.last_name}`,
    },
    {
      key: "overdu_by",
      title: "Overdu by",
      dataIndex: "overdu_by",
      render: (text) => text.replace("-", "/"),
    },
    {
      key: "balance",
      title: (
        <Typography.Paragraph style={{ marginBottom: 0, fontWeight: 600 }} ellipsis>
          Outstanding Balance
        </Typography.Paragraph>
      ),
      dataIndex: "outstanding_balance",
      render: (text) => `$${new Intl.NumberFormat("en-US").format(Number(text))}`,
    },
    {
      key: "action",
      title: "Action",
      render: (_) => <img src={notification} alt="notification" />,
    },
  ];

  return (
    <Card>
      <Flex vertical gap={30}>
        <Typography.Title level={4} style={{ marginBottom: 0 }}>
          Patients with Highest Balance
        </Typography.Title>
        <Table
          columns={patientWithHighestBalanceColumns}
          dataSource={testPatientWithHeighestBalance}
          pagination={false}
          className="fixed-body-height-scroll-top-treatments-by-plan-type"
          sticky
        />
      </Flex>
    </Card>
  );
}
